import Vue from "vue";
import * as api from "~/api/resource";

const fulldomain = window.location.hostname,
    subdomain = fulldomain ? fulldomain.split(".")[0] : 'default'; //'pytheastravel'//
const now = new Date(), endOfMonth = now.getDate() + '/' + (now.getMonth() + 1) + '/' + now.getFullYear(),
    lastDayOfMonth = new Date(new Date().setDate(now.getDate() - 30)),
    startMonth = lastDayOfMonth.getDate() + '/' + (lastDayOfMonth.getMonth() + 1) + '/' + lastDayOfMonth.getFullYear()
export const state = {
    loggedUser: null,
    profile: {
        zantexp: {
            vehicleNotificationTypes: 'vehicleNotificationTypes',
            vehicleTypes: [
                {id: "Car-manual", label: "Car-manual"},
                {id: "Car-auto", label: "Car-auto"},
                {id: "Group-A", label: "Group-A"},
                {id: "Group-B", label: "Group-B"},

            ],
        },
        ionian: {
            vehicleNotificationTypes: [
                {
                    value: 'kteo',
                    label: 'ΚΤΕΟ'
                },
                {
                    value: 'karta_kafsaerion',
                    label: 'Κάρτα Καυσαερίων'
                },
                {
                    value: 'ilektroniko_sima',
                    label: 'Ηλεκτρονικό Σήμα'
                },
                {
                    value: 'taxografos',
                    label: 'Ταχογράφος'
                },
                {
                    value: 'koftis',
                    label: 'Κόφτης'
                },
                {
                    value: 'asfaleia',
                    label: 'Ασφάλεια'
                },
                {
                    value: 'service',
                    label: 'Service'
                },
                {
                    value: 'vevaiosi_zonon_asfaleias',
                    label: 'Βεβαίωση Ζωνών Ασφαλείας'
                },
                {
                    value: 'elastika',
                    label: 'Αλλαγή ελαστικών'
                },
                {
                    value: 'sinergio',
                    label: 'Εργασίες Συνεργείου'
                }
                ,
                {
                    value: 'pirosvestires',
                    label: 'Πυροσβεστήρες'
                }
            ],
            vehicleTypes: [
                {id: "Car-manual", label: "Car-manual"},
                {id: "Car-auto", label: "Car-auto"},
                {id: "Group-A", label: "Group-A"},
                {id: "Group-B", label: "Group-B"},

            ],
        },
        travel: {theme: 'sunny'},
        kayak: {
            invoiceGroups: {A: 'A'},
            canIssueManually: true,
            printers: {
                invoice: {default: "kayak-services-invoice-printer.html?bkid="},
                receipt: {default: "kayak-voucher-printer-excrs.html?bkid="},
                pistotiko: {default: 'kayak-refund-invoice-printer.html?bkid='}
            },
            terms: {
                conditions: 'All confirmed bookings need to be prepayed. The prices are per person per excursion.<br> The booking fee includes the equipment for Kayaking, snorkeling, Water, dry Bag and Pictures which will be takenduring the excursion and send by you after per email.<br>' +
                    'All prices are including VAT.<br>' +
                    'Children under the age of 11,99 are on request and the price will be given to you by us. Please contact us by email on seakayakinzante@gmail.com.',
                cancellation: //'In case the trip is canceled due to weather conditions no charges will be applyed.<br>' +
                    'If you wish to cancell your booking, the following terms will apply:<br>' +
                    '7 days before your excursion - 100% refund of the prepayment<br>' +
                    '4 – 7 days before your excursion - 50% refybd if the prepayment<br>' +
                    '0 – 3 days before your excursion - NO refund.<br>' +
                    'Your cancellation must be from you directly to us by email or mobile phone.<br>'
                    + 'In case the excursion can not be done on your booked date due to unforseen weather changes we will try to find an alternative day. If that is not possible and the excursion will be canceled due to the weather you will receive a full refund of your prepayment. '

            }
        },
        travel2: {
            invoiceGroups: {A: 'A', B: 'B', E: 'F.C.'},
            canIssueManually: true,
            printers: {
                invoice: {default: "travel2-voucher-printer-transfers.html?bkid="},
                receipt: {default: "travel2-voucher-printer-transfers.html?bkid="},
                pistotiko: {default: 'travel2-refund-invoice-printer.html?bkid='}
            },
            excludeGroupsAADE: ['E']
        }
    },
    bookingForm: {
        kriton: {hasTickets: true},
        pytheastravel: {hasTickets: true}, //pytheastravel
        zantexp: {ticketNumber: "auto"}, //abba
    },
    dashboard: {
        pytheastravel: [
            {
                label: "Reports (Last 30 Days)",
                boards: [
                    {
                        size: 24,
                        label: "Rep/Excursions (pax booked)",
                        componentIs: "s-table",
                        componentOptions: {
                            oneLoad: true,
                            lazyLoader: false,
                            rowKeyField: "Rep",
                            modxProcessor: "transdrafts/pivot",
                            rQuery: {
                                pivotrender: true,
                                group_all_aggragators: true,
                                colby: 'TripService',
                                rowby: 'Rep',
                                value: 'Pax',
                                limit: 0,
                                from: 'routes',
                                pivotctx: 'bookings_excrs',
                                timerange_from: startMonth,
                                timerange_to: endOfMonth,
                                pivotFields: '{"AA":{"for":["bookings_excrs"],"name":"AA","aggregator":"concat","field":"Transdrafts.aa","constrain":"aa!=0 and aa is not null","key":"AA","ismain":false},"Ticket":{"for":["bookings_excrs"],"name":"Ticket","aggregator":"concat","field":"Booking.ticketNum","constrain":"aa!=0 and aa is not null","key":"Ticket","ismain":false},"API_DATE":{"for":["bookings_excrs"],"name":"API DATE","aggregator":"concat","field":"Transdrafts.invoice_date","format":"isodate","constrain":"aa!=0 and aa is not null","key":"API_DATE","ismain":false},"TripService":{"for":["Excursions","bookings_excrs"],"name":"TripService","aggregator":"concat","field":"TripService.title","key":"TripService","ismain":false},"Trip_Date":{"for":null,"name":"Trip Date","format":"isodate","aggregator":"concat-eclipse","totalAggregator":"unique-count","field":"ScheduledTrip.time","key":"Trip_Date","ismain":false},"Month":{"for":null,"name":"Month","format":"month","field":"ScheduledTrip.time","key":"Month","ismain":false},"TourCompany":{"for":["Transfers","bookings_excrs"],"name":"TourCompany","field":"TourCompany.coname","details":"coname","aggregator":"concat","totalAggregator":"count","key":"TourCompany","ismain":false},"Rep":{"for":["bookings_excrs"],"name":"Rep","aggregator":"concat","field":"Rep.name","key":"Rep","ismain":false},"Inv_Type":{"for":["bookings_excrs"],"name":"Inv.Type","aggregator":"concat","field":"Transdrafts.type","key":"Inv_Type","ismain":false},"Sell":{"for":["Excursions","bookings_excrs"],"name":"Sell","aggregator":"sum","format":"money","field":"case when Transdrafts.type=``dept`` then Transdrafts.deptamound else Transdrafts.payedamound end","key":"Sell","ismain":true},"Pax":{"for":["Excursions","bookings_excrs"],"name":"Pax","field":"Booking.adults+Booking.children","aggregator":"sum","formula":"Booking.adults+Booking.children","key":"Pax","ismain":true}}'
                            },


                        },
                    },
                    {
                        size: 24,
                        label: "Transfers (pax)",
                        componentIs: "s-table",
                        componentOptions: {
                            rowKeyField: "TourCompany",
                            modxProcessor: "transdrafts/pivot", lazyLoader: false,
                            oneLoad: true,
                            rQuery: {
                                pivotrender: true,
                                group_all_aggragators: true,
                                colby: 'Trans_Type',
                                rowby: 'TourCompany',
                                value: 'Pax',
                                limit: 0,
                                from: 'routes',
                                pivotctx: 'Transfers',
                                timerange_from: startMonth,
                                timerange_to: endOfMonth,
                                pivotFields: '{"Trip_Date":{"for":null,"name":"Trip Date","format":"isodate","aggregator":"concat-eclipse","totalAggregator":"unique-count","field":"Route.date","key":"Trip_Date","ismain":false},"Month":{"for":null,"name":"Month","format":"month","field":"Route.date","key":"Month","ismain":false},"TourCompany":{"for":["Transfers","bookings_excrs"],"name":"TourCompany","field":"TourCompany.coname","details":"coname","aggregator":"concat","totalAggregator":"count","key":"TourCompany","ismain":false},"Agent":{"for":["Transfers"],"name":"Agent","aggregator":"count","field":"Route.distributors","key":"Agent","ismain":false},"Trans_Type":{"for":["Transfers"],"name":"Trans Type","aggregator":"concat","field":"Route.destination","key":"Trans_Type","ismain":false},"Trans_Dir":{"for":["Transfers"],"name":"Trans Dir","aggregator":"concat","field":"Route.direction","key":"Trans_Dir","ismain":false},"Vehicle":{"for":["Transfers"],"name":"Vehicle","aggregator":"concat-eclipse","totalAggregator":"unique-count","field":"Assets.name","key":"Vehicle","ismain":false},"Driver":{"for":["Transfers"],"name":"Driver","aggregator":"concat","field":"Contact.name","key":"Driver","ismain":false},"Pax":{"for":["Transfers"],"name":"Pax","aggregator":"sum","field":"Route.pax","key":"Pax","ismain":true},"Routes":{"for":["Transfers"],"name":"Routes","aggregator":"count","field":"Route.routename","key":"Routes","ismain":true}}'
                            },


                        },
                    },

                ],
                xlinks: [
                    {
                        size: 6,
                        label: "New Car rental",
                        url: "/spa/#/timelineForProducts/Car/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Scouter rental",
                        url: "/spa/#/timelineForProducts/Scouter/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New QuadBike rental",
                        url: "/spa/#/timelineForProducts/QuadBike/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Boat rental",
                        url: "/spa/#/timelineForProducts/Boat/new?initialTime=now",
                    },
                ],
            },
        ],
        kriton: [
            {
                label: "Reports (Last 30 Days)",
                boards: [
                    {
                        size: 12,
                        label: "Companies(Pax)",
                        componentIs: "s-table",
                        componentOptions: {
                            rowKeyField: "TourCompany", oneLoad: true, lazyLoader: false,
                            modxProcessor: "transdrafts/pivot",
                            rQuery: {
                                pivotrender: true,
                                group_all_aggragators: true,
                                colby: 'Trans_Type',
                                rowby: 'TourCompany',
                                value: 'Pax',
                                limit: 0,
                                from: 'routes',
                                pivotctx: 'Transfers',
                                timerange_from: startMonth,
                                timerange_to: endOfMonth,
                                pivotFields: '{"Trip_Date":{"for":null,"name":"Trip Date","format":"isodate","aggregator":"concat-eclipse","totalAggregator":"unique-count","field":"Route.date","key":"Trip_Date","ismain":false},"Month":{"for":null,"name":"Month","format":"month","field":"Route.date","key":"Month","ismain":false},"TourCompany":{"for":["Transfers","bookings_excrs"],"name":"TourCompany","field":"TourCompany.coname","details":"coname","aggregator":"concat","totalAggregator":"count","key":"TourCompany","ismain":false},"Agent":{"for":["Transfers"],"name":"Agent","aggregator":"count","field":"Route.distributors","key":"Agent","ismain":false},"Trans_Type":{"for":["Transfers"],"name":"Trans Type","aggregator":"concat","field":"Route.destination","key":"Trans_Type","ismain":false},"Trans_Dir":{"for":["Transfers"],"name":"Trans Dir","aggregator":"concat","field":"Route.direction","key":"Trans_Dir","ismain":false},"Vehicle":{"for":["Transfers"],"name":"Vehicle","aggregator":"concat-eclipse","totalAggregator":"unique-count","field":"Assets.name","key":"Vehicle","ismain":false},"Driver":{"for":["Transfers"],"name":"Driver","aggregator":"concat","field":"Contact.name","key":"Driver","ismain":false},"Pax":{"for":["Transfers"],"name":"Pax","aggregator":"sum","field":"Route.pax","key":"Pax","ismain":true},"Routes":{"for":["Transfers"],"name":"Routes","aggregator":"count","field":"Route.routename","key":"Routes","ismain":true}}'
                            },
                            colDefinitions: [
                                {
                                    prop: "TourCompany", width: "", label: "Tour Company",

                                },

                                {
                                    prop: "TRANSFER",

                                    label: "Transfers"

                                },

                                {
                                    prop: "PICKUP",

                                    label: "Pickups",

                                },
                                {
                                    prop: "EXCRS", label: "Excursions",

                                }
                            ]

                        },
                    },
                    {
                        size: 12,
                        label: "Drivers (Route count)",
                        componentIs: "s-table",
                        componentOptions: {
                            rowKeyField: "Driver",
                            modxProcessor: "transdrafts/pivot", oneLoad: true, lazyLoader: false,
                            rQuery: {
                                pivotrender: true,
                                group_all_aggragators: true,
                                colby: 'Trans_Type',
                                rowby: 'Driver',
                                value: 'Routes',
                                limit: 0,
                                from: 'routes',
                                pivotctx: 'Transfers',
                                timerange_from: startMonth,
                                timerange_to: endOfMonth,
                                pivotFields: '{"Trip_Date":{"for":null,"name":"Trip Date","format":"isodate","aggregator":"concat-eclipse","totalAggregator":"unique-count","field":"Route.date","key":"Trip_Date","ismain":false},"Month":{"for":null,"name":"Month","format":"month","field":"Route.date","key":"Month","ismain":false},"TourCompany":{"for":["Transfers","bookings_excrs"],"name":"TourCompany","field":"TourCompany.coname","details":"coname","aggregator":"concat","totalAggregator":"count","key":"TourCompany","ismain":false},"Agent":{"for":["Transfers"],"name":"Agent","aggregator":"count","field":"Route.distributors","key":"Agent","ismain":false},"Trans_Type":{"for":["Transfers"],"name":"Trans Type","aggregator":"concat","field":"Route.destination","key":"Trans_Type","ismain":false},"Trans_Dir":{"for":["Transfers"],"name":"Trans Dir","aggregator":"concat","field":"Route.direction","key":"Trans_Dir","ismain":false},"Vehicle":{"for":["Transfers"],"name":"Vehicle","aggregator":"concat-eclipse","totalAggregator":"unique-count","field":"Assets.name","key":"Vehicle","ismain":false},"Driver":{"for":["Transfers"],"name":"Driver","aggregator":"concat","field":"Contact.name","key":"Driver","ismain":false},"Pax":{"for":["Transfers"],"name":"Pax","aggregator":"sum","field":"Route.pax","key":"Pax","ismain":true},"Routes":{"for":["Transfers"],"name":"Routes","aggregator":"count","field":"Route.routename","key":"Routes","ismain":true}}'
                            },
                            colDefinitions: [
                                {
                                    prop: "Driver", width: "", label: "Driver",

                                },

                                {
                                    prop: "TRANSFER",

                                    label: "Transfers"

                                },

                                {
                                    prop: "PICKUP",

                                    label: "Pickups",

                                },
                                {
                                    prop: "EXCRS", label: "Excursions",

                                }
                            ]

                        },
                    },
                ],
                xlinks: [
                    {
                        size: 6,
                        label: "New Car rental",
                        url: "/spa/#/timelineForProducts/Car/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Scouter rental",
                        url: "/spa/#/timelineForProducts/Scouter/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New QuadBike rental",
                        url: "/spa/#/timelineForProducts/QuadBike/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Boat rental",
                        url: "/spa/#/timelineForProducts/Boat/new?initialTime=now",
                    },
                ],
            },
        ],
        zantexp: [
            {
                label: "Rentals",
                boards: [
                    {
                        size: 12,
                        label: "PickUps",
                        componentIs: "nav-table",
                        componentOptions: {
                            type: "rental",
                            context: "pickup",
                        },
                    },
                    {
                        size: 12,
                        label: "DropOffs",
                        componentIs: "nav-table",
                        componentOptions: {
                            type: "rental",
                            context: "dropoff",
                        },
                    },
                ],
                links: [
                    {
                        size: 6,
                        label: "New Car rental",
                        url: "/spa/#/timelineForProducts/Car/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Scouter rental",
                        url: "/spa/#/timelineForProducts/Scouter/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New QuadBike rental",
                        url: "/spa/#/timelineForProducts/QuadBike/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Boat rental",
                        url: "/spa/#/timelineForProducts/Boat/new?initialTime=now",
                    },
                ],
            },
        ],
        ionian: [
            {
                label: "Reports",
                boards: [
                    {
                        size: 12,
                        label: "Fleet Tasks",
                        componentIs: "s-table",
                        componentOptions: {
                            modxProcessor: "fueldrafts/getlist",
                            rQuery: {status: ['high-priority']},
                            colDefinitions: [
                                {
                                    prop: "vehicle", width: "", label: "Vehicle",
                                    onClick(row) {
                                        this.routeGo({
                                            name: "manageVehicle",
                                            params: {vehicleid: row.assetId}
                                        });
                                    }
                                },

                                {
                                    prop: "type",

                                    label: "Type",
                                    onClick(row) {
                                        this.routeGo({
                                            name: "manageVehicle",
                                            params: {vehicleid: row.assetId}
                                        });
                                    }
                                },

                                {
                                    prop: "alerttime",

                                    label: "When",
                                    formatter(val, colDefs, row, vm) {
                                        return vm.dateFromUnxTime(val)
                                    },
                                    onClick(row) {
                                        this.routeGo({
                                            name: "manageVehicle",
                                            params: {vehicleid: row.assetId}
                                        });
                                    }
                                },
                                {
                                    prop: "title", label: "What",
                                    onClick(row) {
                                        this.routeGo({
                                            name: "manageVehicle",
                                            params: {vehicleid: row.assetId}
                                        });
                                    }
                                }
                            ]

                        },
                    },
                    {
                        size: 12,
                        label: "Drivers (Route count) last 30 days",
                        componentIs: "s-table",
                        componentOptions: {
                            rowKeyField: "Driver",
                            modxProcessor: "transdrafts/pivot", oneLoad: true, lazyLoader: false,
                            rQuery: {
                                pivotrender: true,
                                group_all_aggragators: true,
                                colby: 'Trans_Type',
                                rowby: 'Driver',
                                value: 'Routes',
                                limit: 0,
                                from: 'routes',
                                pivotctx: 'Transfers',
                                timerange_from: startMonth,
                                timerange_to: endOfMonth,
                                pivotFields: '{"Trip_Date":{"for":null,"name":"Trip Date","format":"isodate","aggregator":"concat-eclipse","totalAggregator":"unique-count","field":"Route.date","key":"Trip_Date","ismain":false},"Month":{"for":null,"name":"Month","format":"month","field":"Route.date","key":"Month","ismain":false},"TourCompany":{"for":["Transfers","bookings_excrs"],"name":"TourCompany","field":"TourCompany.coname","details":"coname","aggregator":"concat","totalAggregator":"count","key":"TourCompany","ismain":false},"Agent":{"for":["Transfers"],"name":"Agent","aggregator":"count","field":"Route.distributors","key":"Agent","ismain":false},"Trans_Type":{"for":["Transfers"],"name":"Trans Type","aggregator":"concat","field":"Route.destination","key":"Trans_Type","ismain":false},"Trans_Dir":{"for":["Transfers"],"name":"Trans Dir","aggregator":"concat","field":"Route.direction","key":"Trans_Dir","ismain":false},"Vehicle":{"for":["Transfers"],"name":"Vehicle","aggregator":"concat-eclipse","totalAggregator":"unique-count","field":"Assets.name","key":"Vehicle","ismain":false},"Driver":{"for":["Transfers"],"name":"Driver","aggregator":"concat","field":"Contact.name","key":"Driver","ismain":false},"Pax":{"for":["Transfers"],"name":"Pax","aggregator":"sum","field":"Route.pax","key":"Pax","ismain":true},"Routes":{"for":["Transfers"],"name":"Routes","aggregator":"count","field":"Route.routename","key":"Routes","ismain":true}}'
                            },


                        },
                    },
                ],
                xlinks: [
                    {
                        size: 6,
                        label: "New Car rental",
                        url: "/spa/#/timelineForProducts/Car/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Scouter rental",
                        url: "/spa/#/timelineForProducts/Scouter/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New QuadBike rental",
                        url: "/spa/#/timelineForProducts/QuadBike/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Boat rental",
                        url: "/spa/#/timelineForProducts/Boat/new?initialTime=now",
                    },
                ],
            },
        ],
        default: [
            {
                label: "Human traffic",
                boards: [
                    {
                        size: 12,
                        label: "Today",
                        componentIs: "s-table",
                        componentOptions: {
                            modxProcessor: "vue_booking/getlist",
                            rQuery: {plandate: 'today'},
                            colDefinitions: [
                                {

                                    prop: "strip_time",
                                    width: "160px",
                                    label: "Date",
                                    formatter(v, colDefs, row, vm) {
                                        return vm.formatUnxTime(v, false, true)
                                    }
                                },
                                {

                                    prop: "customer",
                                    width: "160px",
                                    label: "Customer",
                                },
                                {

                                    prop: "ppname",
                                    width: "160px",
                                    label: "Place",
                                },
                                {

                                    prop: "tserv_title",
                                    width: "160px",
                                    label: "Status",
                                    alterClickable: true,
                                    link(val, colDefs, row, vm) {
                                        // _log_(">possiblalterClickablee_pp>>>" + val, row);
                                        // if (!row.inv_timologioId) return "";
                                        // // _log_(">poss!!!!!iblalterClickablee_pp>>>" + val, row);
                                        // const url =
                                        //     "/" +
                                        //     Travel.wdb.replace("_", "-") +
                                        //     "voucher-printer-transfers.html?bkid=" +
                                        //     row.inv_timologioId;
                                        return vm.makeBookingLink(row);
                                    },
                                    formatter: function (val, cols, row) {
                                        // _log_(">possiblalterClickablee_pp>>>" + row.refunt_inv_aa, row);
                                        let out = "<div class='status-cell'>";

                                        // if (row.strip_tripType&&row.strip_tripType.toLowerCase == "acom") {}
                                        // else
                                        if (row.strip_tripType && row.strip_tripType.toLowerCase() == "excrs") {
                                            out +=
                                                val == "normal"
                                                    ? '<span title="booking is valide" class="label label-primary"><i class="material-icons">show_chart</i></span>'
                                                    : ' <span title="booking is overbooked" class="label label-warning"><i class="material-icons">multiline_chart</i></span>';
                                            out +=
                                                row.execStatus == "normal"
                                                    ? '<span title="booking is on schedule" class="label label-primary"><i class="material-icons">flash_on</i></span>'
                                                    : ' <span title="booking is not scheduled by us" class="label label-warning"><i class="material-icons">block</i></span>';
                                            let clsP =
                                                row.invoiceinfo == 'block_api' ? "label-danger" : "label-primary";
                                            let clsL = row.locked ? "label-danger" : "label-primary";

                                            out +=
                                                '<span title="booking locked" class="label ' +
                                                clsL +
                                                '"><i class="material-icons">vpn_key</i></span>';
                                            out +=
                                                '<span title="' + (row.invoiceinfo == 'block_api' ? 'no api will be issued' : 'api will be issued') + '" class="label ' +
                                                clsP +
                                                '"><span class="material-icons">' +
                                                'receipt' +
                                                '</span></span>';
                                        } else {
                                            out +=
                                                row.status.toLowerCase()
                                                    .indexOf("cancel") < 0
                                                    ? '<span title="booking status:' +
                                                    row.status +
                                                    '" class="label label-primary"><i class="material-icons">flash_on</i></span>'
                                                    : ' <span title="booking is canceled" class="label label-warning"><i class="material-icons">block</i></span>';
                                            out += row.strip_tripType
                                            out += "</div>";
                                        }
                                        return out;
                                    },
                                }],

                        },
                    },
                    {
                        size: 12,
                        label: "Future",
                        componentIs: "s-table",
                        componentOptions: {
                            modxProcessor: "vue_booking/getlist",
                            rQuery: {range: 'future'},
                            colDefinitions: [
                                {

                                    prop: "strip_time",
                                    width: "160px",
                                    label: "Date",
                                    formatter(v, colDefs, row, vm) {
                                        return vm.formatUnxTime(v, false, true)
                                    }
                                },
                                {

                                    prop: "customer",
                                    width: "160px",
                                    label: "Customer",
                                },
                                {

                                    prop: "ppname",
                                    width: "160px",
                                    label: "Place",
                                },
                                {

                                    prop: "tserv_title",
                                    width: "160px",
                                    label: "Status",
                                    alterClickable: true,
                                    link(val, colDefs, row, vm) {
                                        // _log_(">possiblalterClickablee_pp>>>" + val, row);
                                        // if (!row.inv_timologioId) return "";
                                        // // _log_(">poss!!!!!iblalterClickablee_pp>>>" + val, row);
                                        // const url =
                                        //     "/" +
                                        //     Travel.wdb.replace("_", "-") +
                                        //     "voucher-printer-transfers.html?bkid=" +
                                        //     row.inv_timologioId;
                                        return vm.makeBookingLink(row);
                                    },
                                    formatter: function (val, cols, row) {
                                        // _log_(">possiblalterClickablee_pp>>>" + row.refunt_inv_aa, row);
                                        let out = "<div class='status-cell'>";

                                        // if (row.strip_tripType&&row.strip_tripType.toLowerCase == "acom") {}
                                        // else
                                        if (row.strip_tripType && row.strip_tripType.toLowerCase() == "excrs") {
                                            out +=
                                                val == "normal"
                                                    ? '<span title="booking is valide" class="label label-primary"><i class="material-icons">show_chart</i></span>'
                                                    : ' <span title="booking is overbooked" class="label label-warning"><i class="material-icons">multiline_chart</i></span>';
                                            out +=
                                                row.execStatus == "normal"
                                                    ? '<span title="booking is on schedule" class="label label-primary"><i class="material-icons">flash_on</i></span>'
                                                    : ' <span title="booking is not scheduled by us" class="label label-warning"><i class="material-icons">block</i></span>';
                                            let clsP =
                                                row.invoiceinfo == 'block_api' ? "label-danger" : "label-primary";
                                            let clsL = row.locked ? "label-danger" : "label-primary";

                                            out +=
                                                '<span title="booking locked" class="label ' +
                                                clsL +
                                                '"><i class="material-icons">vpn_key</i></span>';
                                            out +=
                                                '<span title="' + (row.invoiceinfo == 'block_api' ? 'no api will be issued' : 'api will be issued') + '" class="label ' +
                                                clsP +
                                                '"><span class="material-icons">' +
                                                'receipt' +
                                                '</span></span>';
                                        } else {
                                            out +=
                                                row.status.toLowerCase()
                                                    .indexOf("cancel") < 0
                                                    ? '<span title="booking status:' +
                                                    row.status +
                                                    '" class="label label-primary"><i class="material-icons">flash_on</i></span>'
                                                    : ' <span title="booking is canceled" class="label label-warning"><i class="material-icons">block</i></span>';
                                            out += row.strip_tripType
                                            out += "</div>";
                                        }
                                        return out;
                                    },
                                }],

                        },
                    },
                ],
                xlinks: [
                    {
                        size: 6,
                        label: "New Car rental",
                        url: "/spa/#/timelineForProducts/Car/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Scouter rental",
                        url: "/spa/#/timelineForProducts/Scouter/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New QuadBike rental",
                        url: "/spa/#/timelineForProducts/QuadBike/new?initialTime=now",
                    },
                    {
                        size: 6,
                        label: "New Boat rental",
                        url: "/spa/#/timelineForProducts/Boat/new?initialTime=now",
                    },
                ],
            },
        ],
    },

    // user : Medcare.user,
    // roles : Medcare.roles,
};

export const getters = {
    getDashboard: (state) => {
        _log_("getDashboard..", subdomain);
        return subdomain
            ? (state.dashboard[subdomain]
                ? state.dashboard[subdomain]
                : state.dashboard.default)
            : null;
    },
    getBookingForm: (state) => {

        return subdomain
            ? state.bookingForm[subdomain]
                ? state.bookingForm[subdomain]
                : {}
            : null;
    },

    // roles: state => state.roles,
};

export const mutations = {
    setDashboard(state, payload) {
        Vue.set(state.dashboard, payload.domain, payload.data);
        // state.general_store[payload.storename] = payload.data;
    },
    setLoggedUser(state, payload) {
        state.loggedUser = payload
        // state.general_store[payload.storename] = payload.data;
    },
};

export const actions = {
    async getLoggedUser({state, commit}, context) {

        if (!state.loggedUser) {
            try {
                _log_("loggedUser...go load..", state.loggedUser)

                // this.$set(store.state, "loggedUser", true);
                const {data} = await api.fetchProcessor(
                    "gears/userinfo",
                    context
                        ? {
                            loggedCtx: context,
                        }
                        : null
                );
                commit('setLoggedUser', data.results)
                //
                // this.$set(store.state, "loggedUser", data.results);
            } catch (e) {
//user not logged
            }
        }
        return state.loggedUser;
    }
};
